import React from 'react';
import _ from 'underscore';

import Spinner from 'sharedreact/components/Spinner';
import { translate } from 'sharedreact/utils/LanguageSupport';
import Dialog from 'sharedreact/components/Dialog';

type Props = {
  show: boolean,
  language: string,
  legalNotices: string,
  onClose: () => void
};

function _renderLegalNoticesText (text: string) {
  const lines: string[] = text.split('\n');

  const renderedLines: React.ReactNode[] = [];

  let index = 0;
  for (const line of lines) {
    if (line.trim().length ===  0) {
      renderedLines.push(<br key={'line_' + index} />);
      index++;
    } else if (line.startsWith('---')) {
      // skip line
    } else if (line.startsWith('This product')) {
      renderedLines.push(<span key={'line_' + index} className='esko_legalnoticesbold'>{line}</span>);
      index++;
      renderedLines.push(<br key={'line_' + index} />);
      index++;
    } else {
      renderedLines.push(<p key={'line_' + index} className='esko_legalnoticesbody'>{line}</p>);
      index++;    
    }
  }

  return (
    <div>
      {renderedLines}
    </div>
  );
}

class LegalNoticesDialog extends React.Component<Props> {
  private _id: string;

  constructor (props: Props) {
    super(props);

    this._id = 'ae_dialog_legalnotices';
  }


  override render (): React.ReactNode {
    const { language, show, onClose, legalNotices
    } = this.props;
  
    return (
      <Dialog
        id={this._id}
        show={show}
        title={translate('shared.legalnotices.title')}
        language={language}
        onClose={onClose}
      >
        <div className='esko_legalnoticestext'>
          {legalNotices !== ''
            ? _renderLegalNoticesText(legalNotices)
            : <Spinner />
          }
        </div>
      </Dialog>
    );
  }
}

export default LegalNoticesDialog;
